import {pageInfo, getExportData } from './../api';
import { Message } from 'element-ui';
const shipTo = {
  namespaced: true,
  state: {
    total:0,
    pageResp: null,
    exportObj: null
  },
  mutations: {
    PAGE_INFO(state,data){
      state.total = data.total;
      state.pageResp = data.obj || [];
    },
    EXPORT_DATA(state, data) {
      state.exportObj = data;
    }
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj){
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async getExportData({commit}, obj){
      let resp = await getExportData(obj);
      commit('EXPORT_DATA', resp);
    }
  }
}
export default shipTo



// WEBPACK FOOTER //
// ./src/page/md/shipTo/store/shipTo.store.js